import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePortalStore } from "./store";

/** C06 first part: the client's login by the personal login and password the administrator handed out (14.1). */
export function PortalLoginPage() {
  const login = usePortalStore((s) => s.login);
  const notice = usePortalStore((s) => s.notice);
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.username, values.password);
      const me = usePortalStore.getState().me;
      navigate(me?.must_change_password ? "/portal/password" : "/portal", { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Ошибка входа");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="wms-login" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16, boxSizing: "border-box" }}>
      <Card style={{ width: "100%", maxWidth: 420, borderRadius: 16, boxShadow: "var(--wms-shadow-lg)" }}>
        <Typography.Title level={4} style={{ marginTop: 0 }}>
          Кабинет клиента
        </Typography.Title>
        <Typography.Paragraph type="secondary">Вход для сотрудников ТОО и ИП: заявки, статусы, остатки, счета и АВР.</Typography.Paragraph>
        {notice && !error && <Alert type="warning" message={notice} showIcon style={{ marginBottom: 16 }} />}
        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}
        <Form layout="vertical" onFinish={onFinish} size="large">
          <Form.Item name="username" label="Логин" rules={[{ required: true, message: "Введите логин" }]}>
            <Input prefix={<UserOutlined />} autoFocus autoComplete="username" data-testid="portal-login" />
          </Form.Item>
          <Form.Item name="password" label="Пароль" rules={[{ required: true, message: "Введите пароль" }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" data-testid="portal-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading} style={{ height: 44, fontWeight: 600 }} data-testid="portal-submit">
            Войти
          </Button>
        </Form>
        <Typography.Paragraph type="secondary" style={{ marginTop: 16, marginBottom: 0, fontSize: 13 }}>
          Забыли пароль? Обратитесь на склад: администратор выдаст временный пароль, который вы смените при входе.
        </Typography.Paragraph>
      </Card>
    </div>
  );
}
